import * as labels_it from "./labels_it";
import * as labels_en from "./labels_en";


import {React} from "react";


const getLanguage = () => {
    return localStorage.getItem("active_language") || "en";
};

const getText = (label, params) => {

    const _getLocal = () => {
        switch (getLanguage()) {
            case "en":
                {
                    return labels_en;
                }
                break;
            case "it":
                {
                    return labels_it;
                }
                break;
          
        }
    };

    return _getLocal().getText(label, params);
}

export { getText, getLanguage };